const { REACT_APP_PROXY_URL, REACT_APP_PROXY_PORT, NODE_ENV } = process.env;

export const proxy =
  REACT_APP_PROXY_URL && REACT_APP_PROXY_PORT && NODE_ENV === 'development'
    ? `${REACT_APP_PROXY_URL}:${REACT_APP_PROXY_PORT}/`
    : '';
